import { gql, useMutation } from '@apollo/client';

const DOWNLOAD_SIGNED_DOCUMENT = gql`
  mutation DownloadSignedDocument($token: String!) {
    downloadSignedDocument(token: $token) {
      mimeType
      fileName
      fileBase64
    }
  }
`;

export interface DownloadSignedDocumentInput {
  token: string;
}

export interface DownloadSignedDocumentResult {
  downloadSignedDocument: {
    mimeType: string;
    fileName: string;
    fileBase64: string;
  };
}

export function useDownloadSignedDocumentMutation() {
  return useMutation<DownloadSignedDocumentResult, DownloadSignedDocumentInput>(DOWNLOAD_SIGNED_DOCUMENT);
}

const DOWNLOAD_SIGNED_DOCUMENT_BY_ID = gql`
  mutation DownloadSignedDocumentById($id: String!) {
    downloadSignedDocumentById(id: $id) {
      mimeType
      fileName
      fileBase64
    }
  }
`;

export interface DownloadSignedDocumentByIdInput {
  id: string;
}

export interface DownloadSignedDocumentByIdResult {
  downloadSignedDocumentById: {
    mimeType: string;
    fileName: string;
    fileBase64: string;
  };
}

export function useDownloadSignedDocumentByIdMutation() {
  return useMutation<DownloadSignedDocumentByIdResult, DownloadSignedDocumentByIdInput>(DOWNLOAD_SIGNED_DOCUMENT_BY_ID);
}
